import { useState, useRef, useEffect } from 'react';
import './Nav.css';
import AudioPlayer from './Components/AudioPlayer/AudioPlayer';

function NavBar(props) {
  const [activeMenu, setActiveMenu] = useState(false);
  const [transitioningMenu, setTransitioningMenu] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  function menuChange(menuOpen) {
    if (activeMenu === menuOpen) {
      setTransitioningMenu(false); // Transition "exit"
      // setTimeout(() => setActiveMenu(false), 500); // ⬅ auskommentiert
      setActiveMenu(false); // sofort deaktivieren
    } else {
      setTransitioningMenu(true);
      // setTimeout(() => setActiveMenu(menuOpen), 500); // ⬅ auskommentiert
      setActiveMenu(menuOpen); // sofort aktivieren
    }
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  }

  return (
    <div className="menu-container">
      <div className="main-menu">
        <AudioPlayer
          mobile={props.mobile}
          wWidth={windowDimensions.width >= 600}
          // url="http://hallo.ubermorgen.info:8000/radio.mp3"
          url="https://azuracast.0dd.eu/listen/hallo_radio/radio.mp3"
        
        />

        <div className="menu-btn">
          <a href="#" className="m-btn" onClick={() => menuChange("cal")}>
            <i className={activeMenu === "cal" ? "sec-col" : ""}>CALENDAR</i>
          </a>

          <a href="#" className="m-btn" onClick={() => menuChange("info")}>
            <i className={activeMenu === "info" ? "sec-col" : ""}>HALLO:</i>
          </a>
        </div>
      </div>

      {transitioningMenu && (
        <PageMenu wWidth={windowDimensions.width >= 600} isActive={activeMenu}>
          {props[activeMenu]}
        </PageMenu>
      )}
    </div>
  );
}

function PageMenu({ wWidth, children, isActive }) {
  const nodeRef = useRef(null);

  return (
    <div
      ref={nodeRef}
      className={`page-container ${isActive ? "active" : "exit"}`}
    >
      <div className="pageMenu">{children}</div>
    </div>
  );
}

export default NavBar;